import useApiRequest from "@/lib/hooks/use-request";
import {
  DealKanbanBoardResponseDto,
  DealKanbanBoardResponseDtoWithSelectableEntities,
  DealKanbanStageListResponseDto,
  DealSelectableEntitiesResponseDto,
} from "@/lib/interfaces/deals";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import KanbanBoard from "./kanban-board";

const DealsFetcher = ({
  setPageTitle,
  setSelectableEntities,
  setSelectedPipeline,
  selectedPipeline,
}: {
  setPageTitle: Dispatch<SetStateAction<string>>;
  setSelectableEntities: Dispatch<SetStateAction<DealSelectableEntitiesResponseDto | undefined>>;
  setSelectedPipeline: Dispatch<SetStateAction<string>>;
  selectedPipeline: string;
}) => {
  const [items, setItems] = useState<DealKanbanStageListResponseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const [initLoaded, setInitLoaded] = useState(false);
  const { apiRequest } = useApiRequest();

  const getItemsInit = useCallback(async () => {
    setInitLoading(true);
    const response = await apiRequest<DealKanbanBoardResponseDtoWithSelectableEntities>(
      `deals/initial/${selectedPipeline}`,
      "GET",
    );
    setInitLoading(false);
    if (response.data) {
      setItems(response.data.stages);
      setSelectableEntities(response.data.selectableEntities);
      setSelectedPipeline(response.data.selectedPipelineId);
      setPageTitle(response.data.title);
    }
  }, [apiRequest, setPageTitle, setSelectableEntities, setSelectedPipeline, selectedPipeline]);

  const getItemsByPipelineId = useCallback(
    async (id: string) => {
      if (!initLoaded) {
        setInitLoaded(true);
        return;
      }
      setIsLoading(true);
      const response = await apiRequest<DealKanbanBoardResponseDto>(`deals/pipelines/${id}`, "GET");
      setIsLoading(false);
      if (response.data) {
        setItems(response.data.stages);
        setPageTitle(response.data.title);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [apiRequest, setPageTitle, setSelectableEntities, setSelectedPipeline, initLoaded]
  );

  useEffect(() => {
    getItemsInit();
  }, [getItemsInit]);

  useEffect(() => {
    if (selectedPipeline) {
      getItemsByPipelineId(selectedPipeline);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPipeline]);

  return (
    <div>
      <DataFetchParent
        data={items}
        isLoading={isLoading || initLoading}
        renderElement={(response: DealKanbanStageListResponseDto[]) => <KanbanBoard items={response} />}
      />
    </div>
  );
};

export default DealsFetcher;
